import { useTranslation } from 'react-i18next';

const productIds = ['pipe', 'fitting', 'flange', 'pile', 'pe-coating'];

export default function Footer() {
  const { t } = useTranslation();

  const navLinks = [
    { labelKey: 'nav_about', href: '#about' },
    { labelKey: 'nav_products', href: '#products' },
    { labelKey: 'nav_features', href: '#features' },
    { labelKey: 'nav_contact', href: '#contact' },
  ];

  const productNameKeys: Record<string, string> = {
    pipe: 'prod_pipe_name',
    fitting: 'prod_fitting_name',
    flange: 'prod_flange_name',
    pile: 'prod_pile_name',
    'pe-coating': 'prod_pe_coating_name',
  };

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="w-full bg-[#F0EDE8] pt-14 md:pt-20 pb-8 md:pb-10">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 pb-10 md:pb-14 border-b border-[#D4CEC7]">
          {/* Brand */}
          <div className="sm:col-span-2">
            <div className="flex items-center gap-3 mb-4 md:mb-5">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg overflow-hidden shrink-0">
                <img
                  src="/images/logo.jpeg"
                  alt="시너지스틸 CI"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <div className="text-base md:text-lg font-black text-[#1C2E4A] leading-none">시너지스틸</div>
                <div className="text-xs tracking-widest text-[#E8762B]">SYNERGY STEEL</div>
              </div>
            </div>
            <p className="text-[#6B7280] text-sm leading-relaxed max-w-sm mb-4 md:mb-5">
              {t('footer_brand_desc')}
            </p>
            <div className="space-y-2">
              <div className="flex items-start gap-2 text-sm text-[#4A5568]">
                <i className="ri-map-pin-fill text-[#E8762B] text-base mt-0.5 shrink-0"></i>
                <span>(04378) 서울특별시 용산구 한강대로 69 업무동 702호</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-[#4A5568] flex-wrap">
                <i className="ri-phone-fill text-[#E8762B] text-base shrink-0"></i>
                <a href="tel:02-6941-1750" className="hover:text-[#E8762B] transition-colors cursor-pointer">02-6941-1750</a>
                <span className="text-gray-300">|</span>
                <a href="tel:010-7375-1750" className="hover:text-[#E8762B] transition-colors cursor-pointer">010-7375-1750</a>
              </div>
              <div className="flex items-center gap-2 text-sm text-[#4A5568]">
                <i className="ri-mail-fill text-[#E8762B] text-base shrink-0"></i>
                <a href="mailto:workmin@sngsteel.com" className="hover:text-[#E8762B] transition-colors cursor-pointer break-all">workmin@sngsteel.com</a>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-bold text-[#1C2E4A] mb-4 md:mb-5 tracking-wide">{t('footer_nav_title')}</h4>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.labelKey}>
                  <a
                    href={l.href}
                    onClick={(e) => handleNav(e, l.href)}
                    className="text-sm text-[#6B7280] hover:text-[#E8762B] transition-colors cursor-pointer"
                  >
                    {t(l.labelKey)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-sm font-bold text-[#1C2E4A] mb-4 md:mb-5 tracking-wide">{t('footer_products_title')}</h4>
            <ul className="space-y-3">
              {productIds.map((id) => (
                <li key={id}>
                  <a
                    href="#products"
                    onClick={(e) => handleNav(e, '#products')}
                    className="text-sm text-[#6B7280] hover:text-[#E8762B] transition-colors cursor-pointer"
                  >
                    {t(productNameKeys[id])}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 pt-6 md:pt-8">
          <p className="text-xs text-[#9CA3AF]">{t('footer_copyright')}</p>
          <div className="flex items-center gap-3">
            <span className="text-xs text-[#9CA3AF]">Fax: 02-6919-1781</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
